/**
 * @generated SignedSource<<85a1d5d75dca1907d34248eab0b4461a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineIssueIndicator_routineOccasion$data = {
  readonly issueCount: number;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion";
};
export type WidgetTeamScheduleRoutineIssueIndicator_routineOccasion$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineIssueIndicator_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineIssueIndicator_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueCount",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "b44894df36d85cfb0153ff044fec45ee";

export default node;
